import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import queueApi from '../services/api';
import { useLanguage } from '../contexts/LanguageContext';
import { useNetworkStatus } from '../utils/networkStatus';
import './ServiceSelection.css';
import Spinner from './Spinner';

import image1 from '../images/image 74.svg';
import image2 from '../images/image 76.svg';
import image3 from '../images/image 82.svg';
import image4 from '../images/image 77.svg';
import image5 from '../images/image 79.svg';
import image6 from '../images/image 81.svg';

const ServiceSelection = () => {
  const navigate = useNavigate();
  const { getText } = useLanguage();
  const { isOnline } = useNetworkStatus();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setWasOffline(true);
    } else if (wasOffline) {
      setWasOffline(false);
      loadServices();
    }
  }, [isOnline, wasOffline]);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    if (isOnline) {
      try {
        setLoading(true);
        setError('');
        const response = await queueApi.getServices();
        let servicesData = response?.items || (Array.isArray(response) ? response : []);
        setServices(servicesData);
      } catch (err) {
        setError(getText('Ошибка при загрузке услуг. Пожалуйста, попробуйте еще раз.', 'Хангоми боркунии хизматҳо хато рӯй дод. Марҳамат кардан, аз нав кӯшиш кунед.'));
      } finally {
        setLoading(false);
      }
    }
  };

  const getServiceIcon = (name) => {
    const lowerName = name.toLowerCase();
    if (lowerName.includes('гирифтани')) return image1;
    if (lowerName.includes('мушкилот')) return image3;
    if (lowerName.includes('пур')) return image2;
    if (lowerName.includes('машварат')) return image5;
    if (lowerName.includes('шикоят ')) return image6;
    if (lowerName.includes('омӯзиши ')) return image4;
    return image1;
  };

   const handleServiceClick = (service) => {
    if (service?.isFromPhoneNumber) {
      navigate('/app-code', { state: { service } });
    } else {
      navigate('/phone-entry', { state: { service } });
    }
  };

  return (
      <div className="terminal-screen">
        {loading && <Spinner />}
        <div className="terminal-header">
          <h1 className="terminal-main-title">{getText('Электронная очередь', 'Навбати электронӣ')}</h1>
        </div>

        <div className="terminal-grid-container">
          {error ? (
                <div className="status-msg error">{error}</div>
          ) : (
              services.map((service) => (
                  <div
                      key={service.id}
                      className="service-card-item"
                      onClick={() => handleServiceClick(service)}
                  >
                    <div className="service-visual-block">
                      <div className="service-circle-decoration"></div>
                      <img
                          src={getServiceIcon(service.name)}
                          alt="icon"
                          className="service-icon-img"
                      />
                    </div>
                    <div className="service-text-label">
                      {service.name}
                    </div>
                  </div>
              ))
          )}
        </div>
      </div>
  );
};

export default ServiceSelection;